import { create } from 'zustand';

type UseCrossingDocumentAdditionalInformation = {
  eloDriverCanUpdateMrn: boolean | null;
  driverPhoneNumberPrefix: string | null;
  driverPhoneNumber: string | null;
  setEloDriverCanUpdateMrn: (eloDriverCanUpdateMrn: boolean) => void;
  setDriverPhoneNumberPrefix: (driverPhoneNumberPrefix: string | null) => void;
  setDriverPhoneNumber: (driverPhoneNumber: string | null) => void;
};

export const useCrossingDocumentAdditionalInformation = create<UseCrossingDocumentAdditionalInformation>((set) => ({
  eloDriverCanUpdateMrn: null,
  driverPhoneNumberPrefix: null,
  driverPhoneNumber: null,
  setEloDriverCanUpdateMrn: (eloDriverCanUpdateMrn: boolean) => set(() => ({ eloDriverCanUpdateMrn })),
  setDriverPhoneNumberPrefix: (driverPhoneNumberPrefix: string | null) => set(() => ({ driverPhoneNumberPrefix })),
  setDriverPhoneNumber: (driverPhoneNumber: string | null) => set(() => ({ driverPhoneNumber })),
}));
